import React from "react";
import Button from "reactstrap/lib/Button";
import classname from "classnames";

export enum ProductListViewMode {
    cardView = 0,
    listView = 1
}

export interface IProductListViewModeProps {
    className: string;
    viewMode: ProductListViewMode | undefined;
    cardButtonTxt: string;
    listButtonTxt: string;
    setListViewMode: (() => void);
    setCardViewMode: (() => void);
}

export const ProductListViewModeComponent: React.FC<IProductListViewModeProps> = (props: IProductListViewModeProps) => {
    return (
        <div className={props.className}>
            <Button
                className={classname(
                    'card_view',
                    (props.viewMode === ProductListViewMode.cardView) ? 'msc-view-modes__selected' : ''
                )}
                title={props.cardButtonTxt}
                aria-label={props.cardButtonTxt}
                role='button'
                // @ts-ignore
                onClick={props.setCardViewMode}
            />
            <Button
                className={classname(
                    'list_view',
                    (props.viewMode === ProductListViewMode.listView) ? 'msc-view-modes__selected' : ''
                )}
                title={props.listButtonTxt}
                aria-label={props.listButtonTxt}
                role='button'
                // @ts-ignore
                onClick={props.setListViewMode}
            />
        </div>
    );
};
